var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpandIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    fill: "#629361"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35 5V4.75H6.1H5H4.75V5V16V16.25H5H6.1H6.35V16V11.3H13.2899L10.6917 13.8982L10.5156 14.0744L10.6911 14.2512L11.4666 15.0322L11.6434 15.2102L11.8208 15.0328L16.1768 10.6768L16.3536 10.5L16.1768 10.3232L11.8208 5.96722L11.6434 5.78982L11.4666 5.96785L10.6911 6.74885L10.5156 6.92562L10.6917 7.10178L13.2899 9.7H6.35V5Z",
    fill: "#FBFFFB",
    stroke: "#FBFFFB",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpandIcon);
export default __webpack_public_path__ + "static/media/arrow-expand-icon.014c31d62b23ddb51bb5d7f1a60f2d9b.svg";
export { ForwardRef as ReactComponent };